import useHLSStreamingURL from "./useHLSStreamingURL";
import {useMemo} from "react";
import VideoPlayer from "../../basics/video-player/VideoPlayer";
import {VideoPlayerPictureInPicture} from "../../basics/video-player/VideoPlayerPictureInPicture";

const Video = ({
    streamId,
    isStreamLive,
    children,
    forcePictureInPicture,
    onCloseClick,
}) => {
    const {url} = useHLSStreamingURL(streamId);

    const videoProps = useMemo(() => {
        // user forced the stream to stop, but the video is still playing due to buffered fragments?
        // the timeout to detect that the stream has ended also takes a while?
        // set the url to null so he is greeted with a black screen - instantly
        const sources = [{src: isStreamLive ? url : null}];
        return {
            videoType: "live",
            loading: isStreamLive && !sources[0].src,
            showPiP: false,
            sources,
        };
    }, [url, isStreamLive]);

    if (forcePictureInPicture) {
        return (
            <VideoPlayerPictureInPicture
                onCloseClick={onCloseClick}
                video={videoProps}
            />
        );
    }

    return (
        <VideoPlayer
            key={`${streamId}_${isStreamLive}`}
            {...videoProps}
            customButtons={children}
        />
    );
};

export default Video;
